module.exports = __webpack_public_path__ + "static/img/tianjian5.3047a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/caseDetail/tianjian5.png
// module id = kN9K
// module chunks = 15